import ProfileContent from "../content/profileContent";
import Layout from "../layout/Layout";

const Profile = () => {
  return (
    <Layout>
      <ProfileContent />
    </Layout>
  );
};

export default Profile;
